export const oddsBgNeutral = "bg-[color:var(--theme-accent)]";
export const oddsBgUp = "kbv-cs-bg-odds-up-desktop";
export const oddsBgDown = "kbv-cs-bg-odds-down-desktop";

export const oddsDetailTableClass =
  "box-border w-full min-w-[560px] table-fixed border-collapse border-0 text-[13px] [&_tbody_tr_td]:p-1 [&_tbody_tr_td]:align-middle [&_tbody_tr_td]:text-center [&_tbody_tr_td]:text-[13px] [&_tbody_tr_td]:[overflow:visible]";

export const popupPanelClass =
  "relative z-[1000] box-border block min-w-[280px] w-max max-w-[min(720px,calc(100vw-16px))] overflow-visible rounded bg-[color:var(--theme-bg)] font-[Inter,ui-sans-serif,system-ui,sans-serif] text-[13px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] [visibility:visible]";

export const popupScrollClass =
  "box-border max-w-full w-full overflow-x-auto overflow-y-visible p-0 [-webkit-overflow-scrolling:touch]";

export const headTitleClass =
  "kbv-cs-text-popup flex h-9 items-center justify-center bg-[length:contain] bg-center bg-no-repeat text-[13px] font-medium";

export const closeBtnClass =
  "absolute right-2 top-[5px] z-[1001] flex h-5 w-5 cursor-pointer items-center justify-center border-0 bg-transparent p-0";

export const labelCellClass =
  "kbv-cs-text-popup whitespace-nowrap bg-transparent !pr-0 text-left !text-left";
export const grayHeaderCellClass = "bg-transparent text-[color:var(--theme-text-muted)]";

export const tdSepRight = { borderRight: "1px solid var(--theme-btn-border)" };
